<div id="phoenixMenu">
  <app-phoenix-menu-item [currentNode]="rootNode"></app-phoenix-menu-item>
</div>
